import type { SimulatorElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS, HintPosition, SimulatorNavigation } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { SlateElementType, textToRtValue } from '@vedalib/rich-text'

import DemoWrapper from 'components/Editor/EditorElements/decorators/DemoWrapper'
import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import * as s from './SimulatorDemo.module.scss'
import Element from './SimulatorElement'
import bgImage from './assets/bg.png'
import type { SimulatorDemoType } from './simulatorTypes'

const DEMO_VALUE: SimulatorElementValue = {
  showArea: true,
  navigation: SimulatorNavigation.FLEX_END,
  numbering: true,
  items: [
    {
      value: generateId(),
      label: 'Demo Item',
      image: { source: FileUsageSource.url, url: bgImage },
      overlay: null,
      areas: [
        {
          id: '1',
          x: 61.5,
          y: 62,
          width: 11.5,
          height: 10.5,
          itemId: '1',
          hint: {
            text: [
              ...textToRtValue(t('elements.simulator.demo.rtHeader'), SlateElementType.heading4),
              ...textToRtValue(t('elements.simulator.demo.rtDescription')),
            ],
            position: HintPosition.BOTTOM,
            indicator: true,
            onHover: false,
            showCloseButton: true,
          },
        },
      ],
      fields: [
        {
          x: 35,
          y: 30,
          width: '356px',
          height: '48px',
          id: 'field1',
          placeholder: true,
          value: '',
        },
        {
          x: 35,
          y: 45,
          width: '356px',
          height: '48px',
          id: 'field2',
          placeholder: true,
          value: '',
        },
      ],
    },
  ],
}

const SimulatorDemo: SimulatorDemoType = ({ styles, fonts, feedback }) => {
  return (
    <DemoWrapper>
      <div className={s.root}>
        <Element
          element={{
            id: `${CONFIG_ELEMENTS.simulator.type}-demo`,
            type: CONFIG_ELEMENTS.simulator.type,
            value: DEMO_VALUE,
            style: {},
            font: {},
            feedback: {},
          }}
          feedback={feedback}
          font={fonts}
          mode={DEMO_MODE}
          styles={styles}
        />
      </div>
      <div className={s.button}>{t('elements.button.label')}</div>
    </DemoWrapper>
  )
}

export default SimulatorDemo
